import type { Moment } from "moment/moment";
import type { KubernetesLiveResourceHealthStatusCode, KubernetesLiveResourceSyncStatusCode } from "./kubernetesLiveResourceStatusCode";
import type { ResourceSourceType } from "./kubernetesLiveStatusResource";

export type BaseKubernetesLiveStatusDetailedResource = {
    Name: string;
    Namespace: string | null;
    Kind: string;
    HealthStatus: KubernetesLiveResourceHealthStatusCode;
    SyncStatus: KubernetesLiveResourceSyncStatusCode | null;
    ResourceSourceId: string;
    SourceType: ResourceSourceType;
    LastUpdated: Moment;
    ManifestSummary: ManifestSummaryResource | null;
    Children: KubernetesLiveStatusDetailedResource[];
    DesiredResourceId: string | null;
    ResourceId: string | null;
    ExternalLink: ExternalLinkResource | null;
};

export type KubernetesPodLiveStatusDetailedResource = Omit<BaseKubernetesLiveStatusDetailedResource, "Details"> & {
    Kind: "Pod";
    ManifestSummary: PodManifestSummaryResource;
};

export type ArgoCDApplicationLiveStatusDetailedResource = Omit<BaseKubernetesLiveStatusDetailedResource, "Details"> & {
    Kind: "Application";
    ManifestSummary: ArgoCDApplicationManifestSummaryResource;
};

export type KubernetesLiveStatusDetailedResource = BaseKubernetesLiveStatusDetailedResource | KubernetesPodLiveStatusDetailedResource;

export type ManifestSummaryResource = {
    Labels: Record<string, string>;
    Annotations: Record<string, string>;
    CreationTimestamp: Moment;
};

export type PodManifestSummaryResource = ManifestSummaryResource & {
    Containers: string[];
};

export type ArgoCDApplicationManifestSummaryResource = ManifestSummaryResource & {
    SourceSyncDetails: ArgoCDApplicationSourceSyncDetailResource[];
};

type ExternalLinkResource = {
    Label: string;
    Uri: string;
};

export type ArgoCDApplicationSourceSyncDetailResource = {
    Revision: string;
    RepositoryUrl: string;
    Name: string | null;
    IsHelmSource: boolean;
};

export function isPodResource(resource: BaseKubernetesLiveStatusDetailedResource | undefined): resource is KubernetesPodLiveStatusDetailedResource {
    return resource?.Kind === "Pod";
}

export function isArgoCDApplicationResource(resource: BaseKubernetesLiveStatusDetailedResource | undefined): resource is ArgoCDApplicationLiveStatusDetailedResource {
    return resource?.Kind === "Application" && resource.SourceType === "ArgoCDInstance";
}
